function Projects() {
  return (
    <div className="container">
      <h1>My Projects</h1>

      <div className="project-card">
        <h3>Portfolio</h3>
        <p>
          Personal portfolio website built using React to showcase my skills,
          projects, and experience. Deployed using GitHub Pages.
        </p>
        <p>
          <b>Technologies Used:</b> React.js, JavaScript, HTML, CSS, Git & GitHub
        </p>
        <a 
          href="https://github.com/kvenkatasubbarao52/Portfolio" 
          target="_blank" 
          rel="noreferrer"
        >
          View Project
        </a>
      </div>

      <div className="project-card">
        <h3>Student Attendance Analyzer</h3>
        <p>
          College Attendance Analyzer (MVC) is a Java Swing application that tracks
          student attendance, displays charts, calculates percentage, and alerts
          when attendance falls below 75%.
        </p>
        <p>
          <b>Technologies Used:</b> Java, Swing (GUI), MVC Architecture
        </p>
        <a 
          href="https://github.com/kvenkatasubbarao52/Student-attendance-analyzer" 
          target="_blank" 
          rel="noreferrer"
        >
          View Project
        </a>
      </div>

      <div className="project-card">
        <h3>Interactive Sales Data Visualization Dashboard</h3>
        <p>
          Interactive dashboard built using Chart.js with filtering, multiple chart
          types, and export to PNG functionality.
        </p>
        <p>
          <b>Technologies Used:</b> HTML, CSS, JavaScript, Chart.js
        </p>
        <a 
          href="https://github.com/kvenkatasubbarao52/Interactive-Sales-Data-Visualization-Dashboard" 
          target="_blank" 
          rel="noreferrer"
        >
          View Project
        </a>
      </div>

      <div className="project-card">
        <h3>Fake Headline Rewriter</h3>
        <p>
          NLP-based 5-stage pipeline for analyzing news text, detecting fake/bias content, verifying facts, and generating reliable headlines. Combines heuristics with DistilBERT for improved accuracy, with confidence scores and annotated outputs.
        </p>
        <p>
          <b>Technologies Used:</b> Python, NLP, DistilBERT, Hugging Face Transformers, Regex
        </p>
        <a 
          href="https://github.com/kvenkatasubbarao52/Fake-Headline-Rewriter" 
          target="_blank" 
          rel="noreferrer"
        >
          View Project
        </a>
      </div>

    </div>
  );
}

export default Projects;